<template>
  <div class="blog-container" v-loading="loading">
    <div class="blog-wrapper">
      <div class="blog-box">
        <el-breadcrumb
          separator="/"
          style="padding: 20px 0 0 30px; position: absolute; z-index: 10"
        >
          <el-breadcrumb-item v-for="(item, index) in breadList" :key="index">
            {{ item }}
          </el-breadcrumb-item>
        </el-breadcrumb>

        <Editor
          style="border-top: none; overflow-x: hidden; padding: 0 17px"
          :editor-id="editorId"
          :default-config="editorConfig"
          :default-html="blogContent"
          mode="default"
          @onChange="handleChangeContent"
        />

        <div class="line"></div>

        <div class="footer">
          <div
            type="text"
            :class="[isDisabled('prev') && 'disabled', 'page-item']"
            @click="onPageChange('prev')"
          >
            <img :src="prevIcon" style="margin-right: 12px" />
            <span>{{
              texts.articleDetail.pagenation.prev +
              (pageInfo?.upTitle ? " : " + pageInfo.upTitle : "")
            }}</span>
          </div>
          <div
            type="text"
            :class="[isDisabled('next') && 'disabled', 'page-item']"
            @click="onPageChange('next')"
          >
            <span>{{
              texts.articleDetail.pagenation.next +
              (pageInfo?.downTitle ? " : " + pageInfo.downTitle : "")
            }}</span>
            <img :src="nextIcon" style="margin-left: 12px" />
          </div>
        </div>
      </div>
    </div>

    <div class="catalogue-wrapper">
      <!-- <span class="cata-title">{{ texts.catalogueTitle }}</span> -->
      <SideCatalogue
        :catalogueList="catalogueList"
        :currentCataDomId="currentCataDomId"
        @scrollTo="scrollTo"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SideCatalogue from "@/components/sideCatalogue"
import { getArticleById } from "@/api/blog"
import { createEditor, DomEditor, SlateNode } from "@wangeditor/editor"
import Layout from "@/components/layout/index"
import "@wangeditor/editor/dist/css/style.css"
import {
  Editor,
  Toolbar,
  getEditor,
  removeEditor,
} from "@wangeditor/editor-for-vue"
import { mapMutations, mapState } from "vuex"

import { getMedproArticlePage } from "../api/blog"
import { initWebInfo } from "@/utils/autoweb"
import { languageMap } from "../data/list"

export default {
  // props: {
  //   texts: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  components: {
    SideCatalogue,
    Editor,
    Layout,
  },
  name: "Blog",
  data() {
    return {
      prevIcon: require("@/assets/icons/prev.svg"),
      nextIcon: require("@/assets/icons/next.svg"),
      loading: false,
      blogTitle: "",
      blogContent: "",
      updateTime: "",
      catalogueList: [],
      currentCataDomId: "",
      editorId: `w-e-${Math.random().toString().slice(-5)}`,
      editorConfig: {
        // readOnly: true,
      },
      pageInfo: {},
      breadList: [],
    }
  },
  watch: {
    $route: {
      handler(val) {
        val.query.blogid && this.getBlogDetail(val.query.blogid)
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState([
      "title",
      "registerIcon",
      "menulist",
      "menutree",
      "currentBlogId",
      "texts",
      "selectedLanguage",
      "currentEnglishBlogId",
    ]),
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll)
    initWebInfo(this.selectedLanguage)
  },
  methods: {
    ...mapMutations(["SET_CURRENTENGLISHBLOG", "SET_CURRENTBLOG"]),
    handleScroll() {
      // 位置距离（自定义）
      let range = 300
      for (let dom of this.catalogueList) {
        // 获取到该标题的位置 top值
        let top = document.getElementById(dom.id).getBoundingClientRect().top
        if (top >= 0 && top <= range) {
          // 改变currentCataDomId的值
          this.currentCataDomId = dom.id
          // 直接结束，其他dom不需要设置了
          return
        } else if (top > range) {
          // top值不在范围内，直接结束说明之前添加过了currentCataDomId的值
          return
        } else {
          // top值小于0
          // 修改currentCataDomId的值，继续循环doms，可能其他的标题符合修改情况
          this.currentCataDomId = dom.id
        }
      }
    },
    async getBlogDetail(id) {
      this.loading = true
      const resp = await getArticleById({ id })
      this.getPageInfo({
        id,
        columnId: resp.data?.columnId,
        languageFlag: languageMap[this.selectedLanguage].id,
      }) // 获取上下篇信息
      this.SET_CURRENTENGLISHBLOG(resp.data.englishArticleId ?? id)
      this.SET_CURRENTBLOG(resp.data.chineseArticleId ?? id)
      this.breadList = resp.data?.articleTitleList || ["Funlink"] // 面包屑导航列表
      this.blogTitle = resp.data
        ? resp.data.title.replace(/replacestr1024/g, this.title)
        : ""
      this.blogContent = resp.data
        ? resp.data.content.replace(/replacestr1024/g, this.title)
        : ""
      this.updateTime = resp.data ? resp.data.updateTime : ""
      await this.randerContent()
      this.loading = false
    },
    handleChangeContent(editor) {
      const headers = getEditor(this.editorId).getElemsByTypePrefix("header")
      // console.log(headers, "@@@")
      let order_3 = 0,
        order_4 = 1 // 三级标题和四级标题的序号(侧边栏不会出现1 2级标题)
      this.catalogueList = headers.map((header) => {
        const text = SlateNode.string(header)
        const { id, type } = header
        return {
          text,
          id,
          type,
          order:
            type === "header3"
              ? ++order_3 + ". "
              : order_3 + "." + order_4++ + " ", // 序号前缀
        }
      })
    },
    async randerContent() {
      if (getEditor(this.editorId).isDisabled()) {
        await getEditor(this.editorId).enable()
      }
      await getEditor(this.editorId).clear()
      this.$nextTick(() => {
        // console.log(this.blogTitle);
        getEditor(this.editorId).dangerouslyInsertHtml(
          `<p key='${new Date().getTime().toString()}'>${this.blogContent}</p>`
        )
        this.$nextTick(() => {
          this.handleScroll()
          if (!getEditor(this.editorId).isDisabled()) {
            getEditor(this.editorId).disable()
          }
          // getEditor(this.editorId).blur();
          // console.log(getEditor(this.editorId).isFocused());
        })
      })
    },
    scrollTo(id) {
      const h = document.getElementById(id).getBoundingClientRect().top
      const top = document.documentElement.scrollTop
      window.scrollTo(0, h + top - 85)
    },
    async getPageInfo(data) {
      try {
        const resp = await getMedproArticlePage(data)
        this.pageInfo = resp.data
      } catch (e) {
        console.error(e)
      }
    },
    onPageChange(type) {
      const idMap = {
        prev: this.pageInfo.upId,
        next: this.pageInfo.downId,
      }
      const { blogid } = this.$route.query
      const needChange = ![this.pageInfo.upId, this.pageInfo.downId].includes(
        blogid
      )
      if (needChange) {
        this.$router.push({
          query: { blogid: idMap[type] },
        })
      }
    },
    isDisabled(type) {
      const typeMap = {
        prev: !this.pageInfo.upId,
        next: !this.pageInfo.downId,
      }
      return typeMap[type]
    },
  },
}
</script>
<style lang="scss" scoped>
.blog-container {
  padding-right: 16vw;
  box-sizing: border-box;
  position: relative;
  .blog-wrapper {
    height: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    background: rgba(0, 0, 0, 0.03);
    border-right: 1px solid #efefef;
    .blog-box {
      position: relative;
      background: #fff;
      width: 100%;
      ::v-deep(.el-breadcrumb) {
        padding: 23px 0 0 30px !important;
      }
      ::v-deep(.el-breadcrumb__inner) {
        font-size: 15px;
        color: #010007cc;
      }
      ::v-deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
        color: #10121666;
      }
      .line {
        border-bottom: 1px solid #efefef;
        margin-bottom: 22px;
      }
      .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px 20px 30px;
        font-size: 14px;
        color: #010007cc;
        .disabled {
          pointer-events: none;
          opacity: 0.5;
          cursor: not-allowed;
          &:hover {
            background-color: #f5f5f5;
            color: #aaa;
          }
        }
        .page-item {
          cursor: pointer;
        }
      }
    }
  }
  .catalogue-wrapper {
    position: fixed;
    box-sizing: border-box;
    top: 72px;
    right: 0;
    .cata-title {
      font-size: 15px;
      padding: 0 10px;
      line-height: 60px;
      font-weight: 600;
    }
  }
}
</style>
<style lang="scss">
.w-e-text-container [data-slate-editor] {
  overflow-x: hidden;
}
.w-e-scroll {
  font-size: 18px !important;
}
</style>
